import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'

export default class VehicleSelectFormComponent extends Component {


  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} props 
   */
  constructor (props) {
    super(props)
    this.state = {
      suggestions: [],
      value: props.input.value ? props.input.value.plate_number : ''
    }

    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this)
    this.getSuggestion = this.getSuggestion.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
    this.renderSuggestion = this.renderSuggestion.bind(this)
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} param0 
   */
  onSuggestionsFetchRequested ({ value }) {
    this.setState({
      suggestions: this.getSuggestion(value)
    })
  }

  /**
   * --------------------------------------------------------------------------------------------------
   */
  onSuggestionsClearRequested () {
    this.setState({
      suggestions: []
    })
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} event 
   * @param {*} param1 
   */
  onSuggestionSelected (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    this.props.input.onChange(suggestion)
    if (this.props.onValueChange) {
      this.props.onValueChange(suggestion)
    }
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} value 
   * @returns 
   */
  getSuggestion (value) {    
    const inputValue = value.toUpperCase()
    const inputLength = inputValue.length

    if (inputLength === 0) {
      return [...this.props.vehicles]
    }

    let vehicles = this.props.vehicles.filter(item =>
      item.plate_number.toUpperCase().slice(0, inputLength) === inputValue
    )

    if (vehicles.length === 0) {
      return [...this.props.vehicles, {plate_number: value, type: 'new'}]
    }

    return vehicles
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} item 
   * @returns 
   */
  getSuggestionValue (item) {
    return item.plate_number.toUpperCase()
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} item 
   * @returns 
   */
  renderSuggestion (item) {
    if (item.type === 'new' ) {      
      return (<div style={{fontStyle: 'italic'}}  hidden={!this.props.newveicle}>
                Crea nuovo veicolo con targa: <strong>{item.plate_number.toUpperCase()}</strong>
      </div>)            
    } else {
      return (<div>
        <strong>{item.plate_number}</strong> - <span style={{fontStyle: 'italic'}}>{item.VehiclePowerSupply.name}</span>
      </div>)
    }
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @param {*} event 
   * @param {*} param1 
   */
  onChange (event, { newValue }) {
    this.setState({value: newValue})
  }

  /**
   * --------------------------------------------------------------------------------------------------
   * @returns 
   */
  render () {
    return (<div>
      <Autosuggest
        highlightFirstSuggestion
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        onSuggestionSelected={this.onSuggestionSelected}
        alwaysRenderSuggestions
        inputProps={{
          value: this.state.value,
          onChange: this.onChange,
          className: 'resident-login',
          required: this.props.required
        }}
      />
    </div>)
  }
}

VehicleSelectFormComponent.propTypes = {
  vehicles: PropTypes.arrayOf(PropTypes.object)
}



// WEBPACK FOOTER //
// ./src/components/redux-form/VehicleSelectFormComponent.js